if (!customElements.get('shop-the-look')) {
  class ShopTheLook extends HTMLElement {
    constructor() {
      super();

      this.slidesContainer = this.querySelector(".shop-the-look__slides__inner");  
      this.slides = this.querySelectorAll(".shop-the-look__slides__slide");  

      this.arrows = this.querySelectorAll(".shop-the-look__image__arrows button");


      this.nav = this.querySelectorAll(".shop-the-look__image__dots__dot");  

      this.init();
    }

    init() {
      this.flickity = new Flickity(this.slidesContainer, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: true,
        contain: true, 
        selectedAttraction: 0.03,
        friction: 0.8,
        setGallerySize: true,
        percentPosition: false,
        imagesLoaded: true,
        cellAlign: "left"
      });

      this.nav.forEach((item, i) => {
        item.addEventListener('click', () => {
          this.updateNav(item, i);
        });
      })

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => {
            this.nav.forEach((items) => {
                items.classList.remove("__active");
            })
            if (arrow.classList.contains("__basic-arrow__prev")) {
                this.flickity.previous(true);
            } else {
                this.flickity.next(true);
            }
            this.nav[this.flickity.selectedIndex].classList.add("__active");
            this.verticalScrollNav(this.nav[this.flickity.selectedIndex]);
        });
      })

      this.flickity.on('change', (index) => {
        this.updateNav(this.nav[index]);
        this.verticalScrollNav(this.nav[index]);
      })
    }

    updateNav(item, index) {
      this.nav.forEach((items) => {
        items.classList.remove("__active");
      })
      this.flickity.select(index); 
      item.classList.add("__active");

      this.verticalScrollNav(item);
    }

    verticalScrollNav(item) {
      item.parentElement.scrollTo({
        top: (item.offsetTop - item.offsetHeight),
        behavior: 'smooth'
      });
    }
  }
  customElements.define("shop-the-look", ShopTheLook);
}
